import classNames from 'classnames';

import styles from '../Toast.module.css';

import { Text } from '../../Text';
import type { ToastObj } from '../types';
import { ToastSentiment } from '../types';

/** Render a toast with role "alert". */
export function ToastAlert(props: ToastObj) {
  const { sentiment = ToastSentiment.Positive, message } = props;
  return (
    <div role="alert" className={classNames(styles.toast, styles[sentiment])}>
      <div className={styles.document}>
        <Text color="Kale3">{message}</Text>
      </div>
    </div>
  );
}
